var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"auth-form-container"},[_c('div',{staticClass:"auth-form-name"},[_vm._v("Sign in")]),_c('LoginForm',{attrs:{"isAdmin":true,"onSubmit":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }